module.exports = __webpack_public_path__ + "img/369camera.7f446bdf.0467a0a2.png";